<template>
  <v-main fluid class="fill-height d-flex align-center">
    <v-snackbar v-model="alerta.activo"  multi-line vertical top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-row class="justify-center">
      <v-col cols="12" sm="7" md="5" lg="3" class="d-flex align-center">
        <v-card class="pa-4">
          <v-card-text class="py-0 text-center"  v-if="Login">

            <img
              :src="require('@/assets/logo.png')"
              :lazy-src="`https://picsum.photos/10/6?image=${1 * 5 + 10}`"
              aspect-ratio="1.5"
              class=" pa-2 mb-5"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              width="50%" 
              transparent
              loading="lazy"
            >
          </v-card-text>

          <v-card-text class="py-0 px-2" >
            <template v-if="!OlvideContra">
              <v-form ref="form" v-model="valid" >
               
                <label>Correo electrónico</label>
                <v-text-field
                  v-model="correo" 
                  append-icon="mdi-email" 
                  placeholder="email@example.com" 
                  required
                  outlined
                  type="text"
                  dense
                  :rules="emailRules"
                >
                </v-text-field>

                <label>Contraseña</label>
                <v-text-field
                  v-model="password"
                  append-icon="lock"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules"
                  :type="show1 ? 'text' : 'password'"
                  placeholder="**********"
                  @click:append="show1 = !show1"
                  @keyup.enter="ingresar"
                  dense
                  clearable
                  outlined
                  required
                ></v-text-field>
              </v-form>
            </template>
            
            <div v-if="OlvideContra" >
              <v-btn color="primary darken-3" dark small text:to="{name: 'olvidacontra'}">Olvide mi contraseña.</v-btn>
            </div>
          </v-card-text>


          <v-card-actions v-if="!OlvideContra">
            <v-btn 
              :loading="iniciar"
              persistent
              color="primary"  
              block 
              @click="ingresar()" 
              tile
            >
              Iniciar sesión
            </v-btn>
          </v-card-actions>

          <v-card-actions v-if="!OlvideContra" class="text-subtitle-1">
            ¿No tienes cuenta?
            <v-card :to="{ name: 'registro' }" class="elevation-0 transparent primary--text ml-2"> 
              Registrarse
            </v-card>
          </v-card-actions>


          <v-footer v-if="!OlvideContra" class="#f6f9fc text-caption text-center mx-2" color="#f6f9fc">
            <v-spacer></v-spacer>
            Olvide mi contraseña 
            <v-card @click="OlvideContra = true"  class="elevation-0 transparent primary--text ml-2">
              Clic aquí!
            </v-card>
            <v-spacer></v-spacer>
          </v-footer>
        </v-card>
      </v-col>
    </v-row>  
    
    
  </v-main>
</template>

<script>
  import {mapActions , mapGetters} from 'vuex'
  var md5     = require('md5')

  export default {
    data(){
      return{
        url:'',
        login: true, 
        password: '',
        correo:'',
        iniciar: false,
        // tipos_registros: [{id:1, nombre:'Docente'}, {id:2, nombre:'Alumno'}],
        // tipo_registro:{ id:null, nombre:''},
       
        show1: false,
				alerta: { activo: false, texto:'', color:'error' },

        valid: false,
        emailRules    :  [v => !!v || 'requerido'],
        passwordRules    :  [v => !!v || 'requerido'],
        tipoRules     :   [v => !!v || 'Es requerido'],
        OlvideContra: false
      }
    },

    created(){
      this.url  = this.$http.options.root + 'fotos-epic-grass//logo.png'
      if(this.getLogeado){
        this.$router.push({ name: 'home' })  
      }
    },


    computed:{
      ...mapGetters('Login',['getdatosUsuario','getLogeado']),
    },

    methods:{
      // ...mapActions(['guardarDatosUsuario']),
      ...mapActions('Login',['validarUser']),
      ...mapActions('Login',['GetInfoUser' ,]),

      ingresar (){
        this.iniciar = true;
        // this.$http.post('iniciar.sesion', payload).then( response =>{
        //   if(response.body){
        //     // console.log('response', response.body);
        //     this.guardarDatosUsuario(response.body)
        //     // this.alerta = { activo: true, texto: 'BIENVENIDO' + ' ' + response.body.nombres, color:'primary'};
        //     this.$router.push({ name: 'home'})
        //   }else{
        //     this.alerta = { activo: true, texto: 'UPS, ALGO SALIO MAL VERIFICA TU USUARIO Y CONTRASEÑA', color:'error'};
        //   } 
        // }).catch( error =>{
				//   this.alerta = { activo: true, texto: error.body.message, color:'error'};
        // }).finally( ()=>{
        //   this.iniciar = false
        // });

        var usuario = { 
          email   : this.correo, 
          password: md5(this.password)
        };

        this.GetInfoUser(usuario).then(response => {
          if(response == false){
            this.alerta = { activo: true, texto: 'UPS, ALGO SALIO MAL VERIFICA TU USUARIO Y CONTRASEÑA', color:'error'};
            return
          }else if(response == true){
            console.log('response', response);
            this.alerta = { activo: true, texto: 'BIENVENIDO A EPIC GLASS ADMINISTRACIÓN', color:'primary'};
            this.$router.push({ name: 'home' })  
          }else{
            this.alerta = { activo: true, texto:response, color:'primary'};
          }
        }).catch(error =>{
          console.log(error)
        }).finally( ()=>{
          this.iniciar = false
        });
        
      }
    }
  };


</script>



  